//
// Welcome to the annotated FaceTec Device SDK core code for performing secure Liveness Checks!
//
import { FaceTecTestingAPINetworkingRequest } from "../utilities/SampleAppNetworkingRequest";
//
// This is an example self-contained class to perform Liveness Checks with the FaceTec SDK.
// You may choose to further componentize parts of this in your own Apps based on your specific requirements.
//
// Umbral en bytes para distinguir un blob de "init/handshake" de una captura real.
// Las llamadas iniciales del SDK suelen ser de cientos de bytes; las capturas de
// FaceMap o foto de ID son típicamente cientos de KB.
var SDK_CAPTURE_BLOB_THRESHOLD_BYTES = 1024;
var SessionRequestProcessor = /** @class */ (function () {
    function SessionRequestProcessor(demonstrationExternalDatabaseRefID, onCompleteCallback) {
        var _this = this;
        this.requestCount = 0;
        this.captureCount = 0;
        //
        // Part 2:  Handling the Result of a FaceScan
        //
        // This method gets called from inside the FaceTecSDK when some server side process is needed to continue processing
        this.onSessionRequest = function (requestBlob, requestCallback) {
            _this.requestCount++;
            var blobLength = (requestBlob === null || requestBlob === void 0 ? void 0 : requestBlob.length) || 0;
            var isCapture = blobLength >= SDK_CAPTURE_BLOB_THRESHOLD_BYTES;
            if (isCapture)
                _this.captureCount++;
            // Si captureCount > 1, este request representa una captura adicional, lo que
            // implica que el SDK rechazó la captura anterior (foto borrosa, mala luz, etc.)
            // y mostró su pantalla de retry interna pidiendo al usuario otra foto.
            var isLikelyInternalRetry = isCapture && _this.captureCount > 1;
            var retryNumber = isLikelyInternalRetry ? _this.captureCount - 1 : 0;
            console.log("\uD83C\uDFAF [SessionRequest] Petici\u00F3n #".concat(_this.requestCount, " - requestBlob size: ").concat(blobLength, " bytes").concat(isLikelyInternalRetry ? " (retry interno #".concat(retryNumber, ")") : ''));
            try {
                var enviarLog = window.enviarLog;
                if (typeof enviarLog === 'function') {
                    enviarLog('sdk_session_request_sent', {
                        level: 'info',
                        processor: 'session_request',
                        triggerFlow: window.__currentTriggerFlow || '',
                        requestCount: _this.requestCount,
                        captureCount: _this.captureCount,
                        blobLength: blobLength,
                        blobKind: isCapture ? 'capture' : 'init',
                        isLikelyInternalRetry: isLikelyInternalRetry,
                        retryNumber: retryNumber
                    });
                }
            }
            catch (e) {
                console.warn('⚠️ [Log] No se pudo enviar sdk_session_request_sent:', e);
            }
            if (window.updateStepperProgress) {
                var currentPath = window.location.pathname.toLowerCase();
                var isEnroll = currentPath.includes('enroll');
                window.updateStepperProgress(isEnroll ? 3 : 2);
            }
            // Create the simple payload to send to the networking class
            var sessionRequestProcessorPayload = {
                requestBlob: requestBlob,
            };
            if (_this.demonstrationExternalDatabaseRefID !== "") {
                sessionRequestProcessorPayload.externalDatabaseRefID = _this.demonstrationExternalDatabaseRefID;
            }
            console.log('📋 [SessionRequest] Payload preparado:', {
                hasExternalDatabaseRefID: !!_this.demonstrationExternalDatabaseRefID,
                requestBlobLength: requestBlob.length
            });
            // demonstrationExternalDatabaseRefID is included in FaceTec Device SDK Sample App Code for demonstration purposes.
            // In Your App, you will be setting and handling this in Your Webservice code.
            new FaceTecTestingAPINetworkingRequest().send(sessionRequestProcessorPayload, requestCallback);
        };
        // Session is completely done
        this.onFaceTecExit = function (faceTecSessionResult) {
            console.log('🏁 [SessionRequest] Sesión completada');
            console.log('📊 [SessionRequest] Status:', faceTecSessionResult.status);
            console.log('📄 [SessionRequest] Resultado completo:', faceTecSessionResult);
            var internalRetries = Math.max(0, _this.captureCount - 1);
            try {
                var enviarLog = window.enviarLog;
                if (typeof enviarLog === 'function') {
                    enviarLog('sdk_session_processor_exit', {
                        level: 'info',
                        processor: 'session_request',
                        triggerFlow: window.__currentTriggerFlow || '',
                        status: faceTecSessionResult.status,
                        requestCount: _this.requestCount,
                        captureCount: _this.captureCount,
                        internalRetries: internalRetries,
                        hadInternalRetries: internalRetries > 0
                    });
                }
            }
            catch (e) {
                console.warn('⚠️ [Log] No se pudo enviar sdk_session_processor_exit:', e);
            }
            _this.onCompleteCallback(faceTecSessionResult.status);
        };
        this.demonstrationExternalDatabaseRefID = demonstrationExternalDatabaseRefID;
        this.onCompleteCallback = onCompleteCallback;
    }
    return SessionRequestProcessor;
}());
export { SessionRequestProcessor };
